import { Phone, MessageCircle, MapPin } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const FloatingActions = () => {
  const phoneNumber = '919994520043';
  const whatsappMessage = 'Hi! I would like to know more about Insta Cafe.';
  const googleMapsUrl = 'https://maps.google.com/?q=Insta+Cafe+Beach+Road+Nagercoil';

  return (
    <div className="fixed right-4 bottom-4 z-50 flex flex-col gap-3">
      {/* WhatsApp */}
      <a
        href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(whatsappMessage)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="float-action-btn w-14 h-14 bg-green-500 hover:bg-green-600 flex items-center justify-center"
        title="Chat on WhatsApp"
      >
        <MessageCircle className="w-6 h-6 text-white" />
      </a>

      {/* Call */}
      <a
        href={`tel:${phoneNumber}`}
        className="float-action-btn w-14 h-14 bg-primary hover:bg-primary-hover flex items-center justify-center"
        title="Call Now"
      >
        <Phone className="w-6 h-6 text-primary-foreground" />
      </a>

      {/* Google Maps */}
      <a
        href={googleMapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="float-action-btn w-14 h-14 bg-secondary hover:bg-secondary-hover flex items-center justify-center"
        title="Get Directions"
      >
        <MapPin className="w-6 h-6 text-foreground" />
      </a>
    </div>
  );
};

export default FloatingActions;